import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { logout } from '../actions/environment';

import AppBar from '../components/Common/AppBar';

class AppBarContainer extends Component {
    render() {
        return (
            <AppBar { ...this.props } />
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {};
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ logout }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(AppBarContainer);



// WEBPACK FOOTER //
// ./scripts/containers/AppBarContainer.jsx